export class PopoverSettings {
  hasTip = false;
  class  = '';
}
